import PropTypes from "prop-types"
import React from "react"
import { StyledEvent } from "./calendar-styled"
import { styledEvent } from "./event-calendar.module.scss"

export const CustomEvent = ({ event }) => {
  return (
    <StyledEvent className={styledEvent}>
      <strong>{event.title}</strong>
      {event.desc && ":  " + event.desc}
    </StyledEvent>
  )
}

CustomEvent.propTypes = {
  event: PropTypes.object,
}

export const CustomEventAgenda = ({ event, setSelectedEvent }) => {
  return (
    <StyledEvent
      onClick={() => setSelectedEvent(event)}
      className={styledEvent}
    >
      <strong>{event.title}</strong>
      {event.desc && ":  " + event.desc}
    </StyledEvent>
  )
}

CustomEvent.propTypes = {
  event: PropTypes.object,
}
CustomEventAgenda.propTypes = {
  event: PropTypes.object,
  setSelectedEvent: PropTypes.func,
}
